import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { Container } from 'semantic-ui-react';
const NewsletterButtons = (props) => {
  const { content } = props;
  const eventi_principali_action =
    content['@components']?.actions?.object_buttons?.find(
      (el) => el?.id === 'eventi_principali',
    ) ?? null;

  const altri_eventi_action =
    content['@components']?.actions?.object_buttons?.find(
      (el) => el?.id === 'altri_eventi',
    ) ?? null;

  const eventi_comacchio_action =
    content['@components']?.actions?.object_buttons?.find(
      (el) => el?.id === 'eventi_comacchio',
    ) ?? null;

  return !!eventi_principali_action ||
    !!altri_eventi_action ||
    !!eventi_comacchio_action ? (
    <Container className="newsletter-buttons-container">
      {!!eventi_principali_action && (
        <div className="button-container">
          <UniversalLink
            className="ui button primary"
            href={eventi_principali_action?.url}
          >
            {eventi_principali_action.title}
          </UniversalLink>
        </div>
      )}
      {!!altri_eventi_action && (
        <div className="button-container">
          <UniversalLink
            className="ui button primary"
            href={altri_eventi_action?.url}
          >
            {altri_eventi_action.title}
          </UniversalLink>
        </div>
      )}
      {!!eventi_comacchio_action && (
        <div className="button-container">
          <UniversalLink
            className="ui button primary"
            href={eventi_comacchio_action?.url}
          >
            {eventi_comacchio_action.title}
          </UniversalLink>
        </div>
      )}
    </Container>
  ) : (
    <></>
  );
};

export default NewsletterButtons;
